import React, { useCallback, useEffect, useState } from 'react'
import PreviewDialog from '../Preview/Dialog'
import DataGrid from '../../../table/DataGrid'
import FormatDate from '../../../date/FormatDate'
import IconTooltipButton from '../../../button/IconTooltipButton'
import { getLogsAuditSkipAndLimit } from '../../../../services/audit/audit.service'
import { useSelector } from 'react-redux'

const List = () => {
  const [list, setList] = useState([])
  const [totalRows, setTotalRows] = useState(0)
  const [loading, toggleLoading] = useState(true)
  const [show, setShow] = useState(null)
  const state = useSelector(state => state?.filter?.audit || {})
  const skip = useSelector(state => state?.datatable?.audit?.skip || 0)
  const rowsPerPage = useSelector(state => state?.datatable?.audit?.rowsPerPage || 100)
  const columnsTable = useSelector(state => state?.datatable?.audit?.columnsTable || [])
  const loadData = useCallback(async(rowsPerPage, skip) => {
    try {
      toggleLoading(true);
      const filter = {
        ...state?.filter,
        module: state?.filter?.module?.value,
        action: state?.filter?.action?.value,
      }
      const result = await getLogsAuditSkipAndLimit(skip, rowsPerPage, filter)
      toggleLoading(false)
      const { audit, count } = result.data
      setList(audit || [])
      setTotalRows(count)
    } catch (error) {
      toggleLoading(false)
    }
  }, [state, state.filter])

  useEffect(() => {
    loadData(rowsPerPage, skip)
  }, [loadData, rowsPerPage, skip])

  return (
    <>
      <DataGrid
        id='audit-logs'
        rows={list.map((row, index) => ({
          ...row,
          index: index + 1 + rowsPerPage * skip,
          date: <FormatDate date={row.createdAt} pattern="dd/MMM/yyyy hh:mm a" />,
          ip: row.ip,
          module: row.module,
          action: row.action,
          user: row.user?.fullName,
          roles: row.user?.roles?.map((role) => role.name).join(', '),
          actions: 
          <div className='flex items-center gap-4 items-center justify-center'>
            <IconTooltipButton
              title='Preview'
              icon='expand-alt'
              onClick={() => setShow(row._id)}
            />
          </div>
        }))}
        loading={loading}
        totalRows={totalRows}
        skip={skip}
        rowsPerPage={rowsPerPage}
        columns={[
          { label: '#', key: 'index', align: 'center', width: 10, show: true, hide: false  },
          ...columnsTable, 
          { label: 'Actions', key: 'actions', align: 'center', width: 50, show: true, hide: false  }
        ]}
        nameModule='audit'
        labelNoRows="You don't have any audit logs yet"
      />
      { show && 
        <PreviewDialog
          show={show}
          onClose={() => setShow(false)}
        /> 
      }
    </>
  )
}

export default List